/* ============
 * Navigation wrapper component.
 * ============
 *
 * This is the navigation wrapper component.
 */

export default {
  components: {
    VLayout: require('./../../layouts/user/user.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/navigation.js